import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'linkify'
})
export class LinkifyPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    
    // Simple URL regex pattern
    const urlPattern = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    const emailPattern = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
    
    // Replace URLs
    let result = value.replace(urlPattern, '<a href="$1" target="_blank" class="linkified">$1</a>');
    
    // Replace emails
    result = result.replace(emailPattern, '<a href="mailto:$1" class="linkified">$1</a>');
    
    return result;
  }
}
